module.exports = __webpack_public_path__ + "static/media/foto_2.31fdf106.png";